import ExperianIcon from "src/assets/ExperianIcon.svg?react";
import {
  getDefaultExperianColombiaChamberOfCommerce,
  getDefaultExperianColombiaCreditHistoryForLegalEntities,
} from "src/connections/connectionConfigs/experianColombia/experianColombiaResources";
import { ExperianColombiaTemplate } from "src/connections/connectionConfigs/experianColombia/experianColombiaTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const EXPERIAN_COLOMBIA_CONFIG: ConnectionConfig<"experian_colombia"> = {
  icon: ExperianIcon,
  description:
    "Provider of consumer credit, and business information services in Colombia",
  template: ExperianColombiaTemplate,
  name: "Colombia | DataCrédito",
  resources: {
    experian_colombia_credit_history_for_legal_entities: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/credit-bureaus/experian-colombia#credit-history-for-legal-entities-historia-de-credito-pj",
      integrationResource:
        getDefaultExperianColombiaCreditHistoryForLegalEntities,
    },
    experian_colombia_chamber_of_commerce: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/credit-bureaus/experian-colombia#chamber-of-commerce-camara-de-comercio",
      integrationResource: getDefaultExperianColombiaChamberOfCommerce,
    },
  },
};
